import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./Buy.css";
import { SERVER_URL } from "./config";
import LocationSearch from "./LocationSearch";

const MAX_SHUTTLE_LOCATIONS = 3;

const Buy = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const packege = searchParams.get("packege");
  const cost = packege === "premium" ? 750 : packege === "medium" ? 400 : 150;

  // ===== Hebrew invitation (existing) =====
  const [image, setImage] = useState(null);
  const [customInvitationUrl, setCustomInvitationUrl] = useState("");

  // ===== EN / FR invitations (new) =====
  const [useHeForEn, setUseHeForEn] = useState(true);
  const [useHeForFr, setUseHeForFr] = useState(true);

  const [imageEn, setImageEn] = useState(null);
  const [customInvitationUrlEn, setCustomInvitationUrlEn] = useState("");

  const [imageFr, setImageFr] = useState(null);
  const [customInvitationUrlFr, setCustomInvitationUrlFr] = useState("");

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showTranzila, setShowTranzila] = useState(false);
  const [tranzilaUrl, setTranzilaUrl] = useState("");
  const [paymentRef, setPaymentRef] = useState(null);

  const [showLangModal, setShowLangModal] = useState(false);
  const [langTab, setLangTab] = useState("en"); // "en" | "fr"

  // shuttle locations: [{ name_i18n: {he,en,fr} }]
  const [shuttleLocations, setShuttleLocations] = useState([]);

  // נשמור כאן את ה-payload הסופי (אחרי העלאות תמונה)
  const signupDataRef = useRef(null);
  // ref עדכני תמיד לcouponCode ולdiscountPercentage כדי שה-effects לא יהיו stale
  const couponCodeRef = useRef(couponCode);
  const discountPercentageRef = useRef(0);

  useEffect(() => {
    couponCodeRef.current = couponCode;
  }, [couponCode]);

  const DEFAULT_INV_1 = "https://mariage1234.s3.eu-central-1.amazonaws.com/image1.jpeg";
  const DEFAULT_INV_2 = "https://mariage1234.s3.eu-central-1.amazonaws.com/image2.jpeg";
  const DEFAULT_INV_3 = "https://mariage1234.s3.eu-central-1.amazonaws.com/image3.jpeg";

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    brideName: "",
    groomName: "",
    hall: "",
    address: "",
    latitude: null,
    longitude: null,
    date: "",
    hebrew_date: "",
    time: "",
    phone: "",
    invitation: DEFAULT_INV_1,
    invitation_en: DEFAULT_INV_1,
    invitation_fr: DEFAULT_INV_1,
    email: "",
    password: "",
    type: packege,
    extraRecords: 0,
    willMariageCame: false,
    discountPercentage: 0,
    isSeparatedEvent: false,
    askKids: false,
    askVegetarian: false,
    askDrive: false,
    shuttle_locations: [],
    bride_name_en: "",
    groom_name_en: "",
    hall_en: "",
    hebrew_date_en: "",
    bride_name_fr: "",
    groom_name_fr: "",
    hall_fr: "",
    hebrew_date_fr: "",
  });

  const normalizeEmail = (email) => (email || "").trim().toLowerCase();

  // keep EN/FR invitations synced with Hebrew when "use same as Hebrew" enabled
  useEffect(() => {
    setFormData((prev) => {
      const next = { ...prev };
      if (useHeForEn) next.invitation_en = prev.invitation;
      if (useHeForFr) next.invitation_fr = prev.invitation;
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useHeForEn, useHeForFr, formData.invitation]);

  // if askDrive is turned off -> clear shuttle locations
  useEffect(() => {
    if (!formData.askDrive) {
      setShuttleLocations([]);
      setFormData((prev) => ({ ...prev, shuttle_locations: [] }));
    }
  }, [formData.askDrive]);

  const handleLocationSelect = (location) => {
    setFormData((prev) => ({
      ...prev,
      latitude: parseFloat(location.lat.toFixed(6)),
      longitude: parseFloat(location.lng.toFixed(6)),
      address: location.name,
    }));
  };

  const checkEmailExists = async (email) => {
    try {
      const response = await axios.get(`${SERVER_URL}check_email/`, { params: { email } });
      return response.data.exists;
    } catch (error) {
      console.error("Error checking email:", error);
      alert("האימייל כבר קיים במערכת, אנא נסה שנית");
      return true;
    }
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "willMariageCame"
          ? checked
          : name === "extraRecords"
          ? Number(value)
          : type === "checkbox"
          ? checked
          : value,
    }));
  };

  // ===== shuttle helpers (i18n) =====
  const ensureNameI18n = (obj) => {
    const base = obj && typeof obj === "object" ? obj : {};
    const ni = base.name_i18n && typeof base.name_i18n === "object" ? base.name_i18n : {};
    return { ...base, name_i18n: { he: ni.he || "", en: ni.en || "", fr: ni.fr || "" } };
  };

  const cleanShuttleForBackend = (raw) => {
    const arr = Array.isArray(raw) ? raw : [];
    return arr
      .map((x) => {
        const safe = ensureNameI18n(x);
        const he = String(safe.name_i18n.he || "").trim();
        const en = String(safe.name_i18n.en || "").trim();
        const fr = String(safe.name_i18n.fr || "").trim();
        const name_i18n = {};
        if (he) name_i18n.he = he;
        if (en) name_i18n.en = en;
        if (fr) name_i18n.fr = fr;
        return { name_i18n };
      })
      .filter((x) => x.name_i18n && Object.keys(x.name_i18n).length > 0)
      .slice(0, MAX_SHUTTLE_LOCATIONS);
  };

  const validateForm = () => {
    const { email, password, phone } = formData;

    const requiredKeys = [
      "firstName",
      "lastName",
      "brideName",
      "groomName",
      "hall",
      "address",
      "date",
      "hebrew_date",
      "time",
      "phone",
      "email",
      "password",
    ];

    for (const key of requiredKeys) {
      const v = formData[key];
      if (v === null || v === undefined || String(v).trim() === "") {
        alert("כל השדות חייבים להיות מלאים");
        return false;
      }
    }

    if (formData.askDrive) {
      const cleaned = cleanShuttleForBackend(shuttleLocations);
      if (cleaned.length === 0) {
        alert("אם סימנת לשאול על הסעה – חובה להוסיף לפחות מקום אחד להסעה (בעברית/אנגלית/צרפתית).");
        return false;
      }
      if (cleaned.length > MAX_SHUTTLE_LOCATIONS) {
        alert("אפשר עד 3 מקומות להסעה.");
        return false;
      }
    }

    if (!termsAccepted) {
      alert("עליך לאשר את תנאי השימוש ואת מדיניות הפרטיות");
      return false;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!passwordRegex.test(password)) {
      alert("הסיסמא צריכה להיות באורך שמונה תווים לפחות ולהכיל לפחות אות אחת גדולה, אות אחת קטנה, ומספר");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("נא להקליד כתובת אימייל תקינה");
      return false;
    }

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      alert("על מספר הטלפון לכלול 10 מספרים בלבד");
      return false;
    }

    return true;
  };

  const handleImageChange = (lang) => (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    if (lang === "he") {
      setImage(file);
      setCustomInvitationUrl(previewUrl);
      setFormData((prev) => ({ ...prev, invitation: previewUrl }));
      return;
    }

    if (lang === "en") {
      setUseHeForEn(false);
      setImageEn(file);
      setCustomInvitationUrlEn(previewUrl);
      setFormData((prev) => ({ ...prev, invitation_en: previewUrl }));
      return;
    }

    if (lang === "fr") {
      setUseHeForFr(false);
      setImageFr(file);
      setCustomInvitationUrlFr(previewUrl);
      setFormData((prev) => ({ ...prev, invitation_fr: previewUrl }));
    }
  };

  const uploadImageToS3 = async (file) => {
    if (!file) return "";
    const fd = new FormData();
    fd.append("file", file);
    try {
      const response = await axios.post(`${SERVER_URL}upload/`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.url || "";
    } catch (error) {
      console.error("Image upload failed:", error);
      return "";
    }
  };

  const handleSignup = useCallback(async (appliedDiscount, dataOverride = null) => {
    try {
      const baseData = dataOverride || signupDataRef.current || formData;
      const updatedFormData = { ...baseData, discountPercentage: appliedDiscount };
      await axios.post(SERVER_URL + "signup/", updatedFormData);
      alert("ההרשמה הסתיימה בהצלחה!");
      navigate("/login");
    } catch (error) {
      console.error("Signup error:", error.response?.data || error.message);
      alert("Signup failed. Please contact support.");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  // ============================================================
  // handlePaymentSuccess — stable ref כדי שה-effects יוכלו לקרוא לה
  // ============================================================
  const handlePaymentSuccess = useCallback(async (appliedDiscount, dataOverride = null) => {
    setLoading(true);
    try {
      const coupon = couponCodeRef.current;
      if (coupon) {
        await axios.post(`${SERVER_URL}use_coupon`, { name: coupon });
      }
      setShowTranzila(false);
      await handleSignup(appliedDiscount, dataOverride || signupDataRef.current);
    } catch (error) {
      console.error("Error using coupon:", error);
      alert("❌ שגיאה בסיום התהליך. לתמיכה פנו ל0542317742");
    } finally {
      setLoading(false);
    }
  }, [handleSignup]);

  const startTranzilaPayment = async (appliedDiscount = 0, dataOverride = null) => {
    try {
      const data = dataOverride || signupDataRef.current || formData;

      const base = cost + Number(data.extraRecords || 0) + (data.willMariageCame ? 1200 : 0);
      const discountPercent = appliedDiscount || data.discountPercentage || 0;
      const finalAmount = base - base * (discountPercent / 100);

      discountPercentageRef.current = discountPercent;

      if (finalAmount <= 0) {
        await handlePaymentSuccess(discountPercent, data);
        return;
      }

      const resp = await axios.post(`${SERVER_URL}trz_direct_init/`, {
        amount: finalAmount,
        email: data.email,
        giver_name: `${data.firstName} ${data.lastName}`,
        phone: data.phone,
        invitation_token: null,
      });

      if (!resp.data.ok) {
        alert("שגיאה בהתחלת התשלום, נסי שוב או פני לתמיכה");
        return;
      }

      setTranzilaUrl(resp.data.iframe_url);
      setPaymentRef(resp.data.payment_ref);
      setShowTranzila(true);
    } catch (err) {
      console.error("Tranzila init error", err);
      alert("שגיאה בהתחלת התשלום, נסי שוב או פני לתמיכה");
    }
  };

  const handleCouponSubmit = async () => {
    if (couponCode.trim() !== "") {
      try {
        const response = await axios.get(`${SERVER_URL}validate_coupon`, {
          params: { name: couponCode },
        });

        if (response.data.sale) {
          const salePercentage = response.data.sale;
          setDiscount(salePercentage);

          setFormData((prev2) => ({
            ...prev2,
            discountPercentage: salePercentage,
          }));
          discountPercentageRef.current = salePercentage;

          alert(`✅ קוד קופון אומת! ההנחה שלך היא ${salePercentage}%.`);

          const data = signupDataRef.current || formData;

          if (salePercentage === 100) {
            alert("🎉 המחיר לאחר ההנחה הוא 0 ₪, התשלום לא נדרש.");
            await handlePaymentSuccess(salePercentage, data);
          } else {
            await startTranzilaPayment(salePercentage, data);
          }
        }
      } catch (error) {
        console.error("❌ Error validating coupon:", error);
        alert("⚠️ קוד קופון זה לא זמין, אנא נסו שנית");
      }
    }
  };

  const handlePopupChoice = async (choice) => {
    const willCome = choice === "yes";

    setFormData((prev) => ({ ...prev, willMariageCame: willCome }));

    if (signupDataRef.current) {
      signupDataRef.current = { ...signupDataRef.current, willMariageCame: willCome };
    }

    setShowPopup(false);

    const data = signupDataRef.current || { ...formData, willMariageCame: willCome };

    if (!couponCode.trim()) {
      await startTranzilaPayment(discountPercentageRef.current || 0, data);
    } else {
      await handleCouponSubmit();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const normalizedEmail = normalizeEmail(formData.email);
    const emailExists = await checkEmailExists(normalizedEmail);

    if (emailExists) {
      alert("האימייל כבר רשום במערכת. אנא השתמש באימייל אחר.");
      return;
    }

    const maxSize = 2 * 1024 * 1024;
    for (const f of [image, imageEn, imageFr]) {
      if (f && f.size > maxSize) {
        alert("גודל הקובץ גדול מדי. אנא בחר תמונה קטנה מ-2MB.");
        return;
      }
    }

    setLoading(true);
    try {
      let heUrl = "";
      let enUrl = "";
      let frUrl = "";

      if (image) {
        heUrl = await uploadImageToS3(image);
        if (!heUrl) {
          alert("העלאת התמונה בעברית נכשלה. נא לנסות שוב.");
          return;
        }
      }

      if (!useHeForEn && imageEn) {
        enUrl = await uploadImageToS3(imageEn);
        if (!enUrl) {
          alert("העלאת התמונה באנגלית נכשלה. נא לנסות שוב.");
          return;
        }
      }

      if (!useHeForFr && imageFr) {
        frUrl = await uploadImageToS3(imageFr);
        if (!frUrl) {
          alert("העלאת התמונה בצרפתית נכשלה. נא לנסות שוב.");
          return;
        }
      }

      const cleanedShuttle = formData.askDrive ? cleanShuttleForBackend(shuttleLocations) : [];

      const finalData = {
        ...formData,
        email: normalizeEmail(formData.email),
        invitation: heUrl || formData.invitation,
        invitation_en: useHeForEn ? (heUrl || formData.invitation) : enUrl || formData.invitation_en,
        invitation_fr: useHeForFr ? (heUrl || formData.invitation) : frUrl || formData.invitation_fr,
        shuttle_locations: cleanedShuttle,
      };

      signupDataRef.current = finalData;
      setFormData(finalData);
      discountPercentageRef.current = finalData.discountPercentage || 0;

      if (!finalData.willMariageCame) {
        setShowPopup(true);
        return;
      }

      if (!couponCode.trim()) {
        await startTranzilaPayment(finalData.discountPercentage || 0, finalData);
      } else {
        await handleCouponSubmit();
      }
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // מנגנון 1: postMessage מה-iframe של טרנזילה (trz_payment_return)
  // ============================================================
  useEffect(() => {
    if (!showTranzila || !paymentRef) return;

    const handler = (event) => {
      if (!event.data || event.data.type !== "tranzila_done") return;
      if (event.data.ref !== paymentRef) return;

      const { status } = event.data;
      console.log("TRZ postMessage received:", event.data);

      if (status === "PAID") {
        setShowTranzila(false);
        handlePaymentSuccess(
          discountPercentageRef.current || 0,
          signupDataRef.current
        );
      } else if (status === "FAIL") {
        setShowTranzila(false);
        alert("התשלום לא עבר. נסה שוב או פנה לתמיכה.");
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [showTranzila, paymentRef, handlePaymentSuccess]);

  // ============================================================
  // מנגנון 2: polling על payments_status (גיבוי למקרה שpostMessage לא מגיע)
  // ============================================================
  useEffect(() => {
    if (!showTranzila || !paymentRef) return;

    const interval = setInterval(async () => {
      try {
        const resp = await axios.get(`${SERVER_URL}payments_status`, {
          params: { ref: paymentRef },
        });

        if (resp.data.ok && resp.data.status === "PAID") {
          clearInterval(interval);
          setShowTranzila(false);
          await handlePaymentSuccess(
            discountPercentageRef.current || 0,
            signupDataRef.current
          );
        } else if (resp.data.ok && resp.data.status === "FAIL") {
          clearInterval(interval);
          setShowTranzila(false);
          alert("התשלום לא עבר. נסה שוב או פנה לתמיכה.");
        }
      } catch (err) {
        console.error("payments_status polling error:", err);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [showTranzila, paymentRef, handlePaymentSuccess]);

  // ==========================
  // UI helpers
  // ==========================

  const renderHebrewInvitationPicker = () => (
    <div style={{ marginTop: 22, paddingTop: 10, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
      <p className="invitation-text" style={{ fontWeight: 800 }}>
        הזמנה בעברית (ברירת מחדל)
      </p>

      <p className="invitation-text" style={{ marginTop: 6 }}>
        תמונה זו תישלח למוזמנים ביחד עם פרטי האירוע:
      </p>

      <div className="invitation-options">
        <div className={`invitation-option ${formData.invitation === DEFAULT_INV_1 ? "selected" : ""}`}>
          <input
            type="radio"
            name="invitation"
            value={DEFAULT_INV_1}
            checked={formData.invitation === DEFAULT_INV_1}
            onChange={handleChange}
          />
          <img src="image1.png" alt="Invitation 1" onClick={() => setFormData((prev) => ({ ...prev, invitation: DEFAULT_INV_1 }))} />
        </div>

        <div className={`invitation-option ${formData.invitation === DEFAULT_INV_2 ? "selected" : ""}`}>
          <input
            type="radio"
            name="invitation"
            value={DEFAULT_INV_2}
            checked={formData.invitation === DEFAULT_INV_2}
            onChange={handleChange}
          />
          <img src="image2.png" alt="Invitation 2" onClick={() => setFormData((prev) => ({ ...prev, invitation: DEFAULT_INV_2 }))} />
        </div>

        <div className={`invitation-option ${formData.invitation === DEFAULT_INV_3 ? "selected" : ""}`}>
          <input
            type="radio"
            name="invitation"
            value={DEFAULT_INV_3}
            checked={formData.invitation === DEFAULT_INV_3}
            onChange={handleChange}
          />
          <img src="image3.png" alt="Invitation 3" onClick={() => setFormData((prev) => ({ ...prev, invitation: DEFAULT_INV_3 }))} />
        </div>

        <div className={`upload-option ${formData.invitation === customInvitationUrl ? "selected" : ""}`}>
          <input
            type="radio"
            name="invitation"
            value={customInvitationUrl}
            checked={!!customInvitationUrl && formData.invitation === customInvitationUrl}
            onChange={() => customInvitationUrl && setFormData((prev) => ({ ...prev, invitation: customInvitationUrl }))}
          />

          <input type="file" accept="image/*" id="fileUploadHe" onChange={handleImageChange("he")} />
          {!customInvitationUrl && <label htmlFor="fileUploadHe">העלה תמונה משלך (עברית)</label>}

          {customInvitationUrl && (
            <div className="image-preview">
              <img src={customInvitationUrl} alt="Preview Hebrew" />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderExtraLangUploader = (langKey) => {
    const isEn = langKey === "en";
    const title = isEn ? "הזמנה באנגלית (אופציונלי)" : "הזמנה בצרפתית (אופציונלי)";
    const desc = isEn
      ? "אם יש לך מוזמנים מחו״ל באנגלית – אפשר להעלות הזמנה באנגלית. אחרת, אפשר להשאיר כמו בעברית."
      : "אם יש לך מוזמנים מצרפת/דוברי צרפתית – אפשר להעלות הזמנה בצרפתית. אחרת, אפשר להשאיר כמו בעברית.";

    const useHe = isEn ? useHeForEn : useHeForFr;
    const setUseHe = isEn ? setUseHeForEn : setUseHeForFr;

    const fileId = isEn ? "fileUploadEn" : "fileUploadFr";
    const previewUrl = isEn ? customInvitationUrlEn : customInvitationUrlFr;
    const setPreviewUrl = isEn ? setCustomInvitationUrlEn : setCustomInvitationUrlFr;
    const setFile = isEn ? setImageEn : setImageFr;

    const fieldName = isEn ? "invitation_en" : "invitation_fr";
    const currentValue = formData[fieldName];

    return (
      <div style={{ marginTop: 18 }}>
        <p className="invitation-text" style={{ fontWeight: 700 }}>{title}</p>
        <p className="invitation-text" style={{ marginTop: 6 }}>{desc}</p>

        <div className="terms" style={{ marginTop: 8 }}>
          <label>
            <input
              type="checkbox"
              checked={useHe}
              onChange={(e) => {
                const checked = e.target.checked;
                setUseHe(checked);
                if (checked) {
                  setFile(null);
                  setPreviewUrl("");
                  setFormData((prev) => ({ ...prev, [fieldName]: prev.invitation }));
                }
              }}
            />
            <span>השתמש באותה הזמנה כמו בעברית</span>
          </label>
        </div>

        {!useHe && (
          <div className="invitation-options" style={{ marginTop: 10 }}>
            <div className={`upload-option ${currentValue === previewUrl ? "selected" : ""}`}>
              <input
                type="radio"
                name={fieldName}
                value={previewUrl}
                checked={!!previewUrl && currentValue === previewUrl}
                onChange={() => previewUrl && setFormData((prev) => ({ ...prev, [fieldName]: previewUrl }))}
              />
              <input type="file" accept="image/*" id={fileId} onChange={handleImageChange(langKey)} />
              {!previewUrl && <label htmlFor={fileId}>{isEn ? "העלה הזמנה באנגלית" : "העלה הזמנה בצרפתית"}</label>}
              {previewUrl && (
                <div className="image-preview">
                  <img src={previewUrl} alt={isEn ? "Preview English" : "Preview French"} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderShuttleBox = (title) => (
    <div className="shuttle-box">
      <div className="shuttle-title">{title}</div>

      {shuttleLocations.map((locRaw, idx) => {
        const loc = ensureNameI18n(locRaw);
        return (
          <div key={`sh-${idx}`} className="shuttle-row" style={{ alignItems: "flex-start", gap: 10 }}>
            <div style={{ display: "grid", gap: 8, flex: 1 }}>
              <input
                type="text"
                value={loc.name_i18n.he}
                onChange={(e) => {
                  const v = e.target.value;
                  setShuttleLocations((prev) =>
                    prev.map((p, i) =>
                      i === idx ? { ...ensureNameI18n(p), name_i18n: { ...ensureNameI18n(p).name_i18n, he: v } } : p
                    )
                  );
                }}
                placeholder="שם מקום בעברית (למשל: ירושלים)"
              />
              <input
                type="text"
                value={loc.name_i18n.en}
                onChange={(e) => {
                  const v = e.target.value;
                  setShuttleLocations((prev) =>
                    prev.map((p, i) =>
                      i === idx ? { ...ensureNameI18n(p), name_i18n: { ...ensureNameI18n(p).name_i18n, en: v } } : p
                    )
                  );
                }}
                placeholder="Location name in English (optional)"
                dir="ltr"
              />
              <input
                type="text"
                value={loc.name_i18n.fr}
                onChange={(e) => {
                  const v = e.target.value;
                  setShuttleLocations((prev) =>
                    prev.map((p, i) =>
                      i === idx ? { ...ensureNameI18n(p), name_i18n: { ...ensureNameI18n(p).name_i18n, fr: v } } : p
                    )
                  );
                }}
                placeholder="Nom du lieu en français (optionnel)"
                dir="ltr"
              />
            </div>

            <button
              type="button"
              className="shuttle-remove"
              onClick={() => setShuttleLocations((prev) => prev.filter((_, i) => i !== idx))}
              aria-label="מחיקה"
              style={{ marginTop: 2 }}
            >
              מחק
            </button>
          </div>
        );
      })}

      <button
        type="button"
        className="shuttle-add"
        disabled={shuttleLocations.length >= MAX_SHUTTLE_LOCATIONS}
        onClick={() => {
          setShuttleLocations((prev) => {
            if (prev.length >= MAX_SHUTTLE_LOCATIONS) return prev;
            return [...prev, { name_i18n: { he: "", en: "", fr: "" } }];
          });
        }}
      >
        + הוספת מקום
      </button>

      <div className="shuttle-hint" style={{ marginTop: 8, opacity: 0.85 }}>
        אפשר למלא רק עברית אם רוצים. אם יש מוזמנים באנגלית/צרפתית — מומלץ למלא גם את השדות שלהם.
      </div>
    </div>
  );

  const renderExtraLangDetails = (langKey) => {
    const isEn = langKey === "en";
    const title = isEn ? "פרטי אירוע באנגלית (אופציונלי)" : "פרטי אירוע בצרפתית (אופציונלי)";

    const brideKey = isEn ? "bride_name_en" : "bride_name_fr";
    const groomKey = isEn ? "groom_name_en" : "groom_name_fr";
    const hallKey = isEn ? "hall_en" : "hall_fr";
    const hebrewDateKey = isEn ? "hebrew_date_en" : "hebrew_date_fr";

    return (
      <div style={{ marginTop: 18, paddingTop: 12, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
        <p className="invitation-text" style={{ fontWeight: 800 }}>{title}</p>
        <p className="invitation-text" style={{ marginTop: 6 }}>
          אם תשאירו ריק — נשתמש בפרטים בעברית כברירת מחדל.
        </p>

        <label>
          שם הכלה ({isEn ? "EN" : "FR"}):
          <input
            type="text"
            name={brideKey}
            value={formData[brideKey]}
            onChange={handleChange}
            placeholder={isEn ? "Bride name" : "Nom de la mariée"}
          />
        </label>

        <label>
          שם החתן ({isEn ? "EN" : "FR"}):
          <input
            type="text"
            name={groomKey}
            value={formData[groomKey]}
            onChange={handleChange}
            placeholder={isEn ? "Groom name" : "Nom du marié"}
          />
        </label>

        <label>
          שם האולם ({isEn ? "EN" : "FR"}):
          <input
            type="text"
            name={hallKey}
            value={formData[hallKey]}
            onChange={handleChange}
            placeholder={isEn ? "Hall name" : "Nom de la salle"}
          />
        </label>

        <label>
          תאריך עברי ({isEn ? "EN" : "FR"}) — טקסט חופשי:
          <input
            type="text"
            name={hebrewDateKey}
            value={formData[hebrewDateKey]}
            onChange={handleChange}
            placeholder={isEn ? "e.g. 23 Kislev / ..." : "ex. 23 Kislev / ..."}
          />
        </label>

        {formData.askDrive && (
          <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
            <p className="invitation-text" style={{ fontWeight: 800 }}>
              {isEn ? "Shuttle locations (optional translations)" : "Lieux de navette (traductions optionnelles)"}
            </p>
            <p className="invitation-text" style={{ marginTop: 6, opacity: 0.9 }}>
              {isEn
                ? "Fill the English/French names for each shuttle pickup point (you can leave them empty)."
                : "Remplis les noms en anglais/français pour chaque point de départ (tu peux laisser vide)."}
            </p>
            {renderShuttleBox("מיקומי הסעה (עד 3) — עברית / English / Français")}
          </div>
        )}
      </div>
    );
  };

  const renderLangModal = () => {
    if (!showLangModal) return null;
    const activeLang = langTab;
    const isEn = activeLang === "en";

    return (
      <div className="popup-overlay popup-overlay--scroll" role="dialog" aria-modal="true">
        <div className="popup-box popup-box--scroll lang-modal">
          <button
            type="button"
            onClick={() => setShowLangModal(false)}
            aria-label="סגירה"
            className="lang-modal__close"
          >
            ×
          </button>

          <h2 className="lang-modal__title">אנגלית / צרפתית (אופציונלי)</h2>

          <p className="invitation-text lang-modal__subtitle">
            כאן אפשר להעלות הזמנה לשפה נוספת וגם למלא פרטי אירוע באותה שפה.
            השינויים נשמרים כחלק מהרישום.
          </p>

          <div className="lang-tabs">
            <button
              type="button"
              onClick={() => setLangTab("en")}
              className={`lang-tab ${isEn ? "is-active" : ""}`}
            >
              English
            </button>
            <button
              type="button"
              onClick={() => setLangTab("fr")}
              className={`lang-tab ${!isEn ? "is-active" : ""}`}
            >
              Français
            </button>
          </div>

          <div className="lang-modal__content">
            {renderExtraLangUploader(activeLang)}
            {renderExtraLangDetails(activeLang)}
          </div>

          <div className="lang-modal__footer">
            <button type="button" onClick={() => setShowLangModal(false)}>
              סגור
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ==========================
  // RENDER
  // ==========================

  return (
    <div className="buy-bg">
      <div className="buy-container">
        <h1>פרטים אישיים והרשמה</h1>
        <p className="invitation-text">ניתן לשנות את כל הפרטים בכל שלב לאחר ההרשמה</p>

        <form onSubmit={handleSubmit}>
          <label>
            שם פרטי:
            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
          </label>

          <label>
            שם משפחה:
            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
          </label>

          <label>
            שם הכלה:
            <input type="text" name="brideName" value={formData.brideName} onChange={handleChange} required />
          </label>

          <label>
            שם החתן:
            <input type="text" name="groomName" value={formData.groomName} onChange={handleChange} required />
          </label>

          <label>
            כתובת אולם:
            <LocationSearch onLocationSelect={handleLocationSelect} />
          </label>

          <label>
            שם האולם:
            <input type="text" name="hall" value={formData.hall} onChange={handleChange} required />
          </label>

          <label>
            תאריך האירוע:
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
          </label>

          <label>
            תאריך עברי:
            <input type="text" name="hebrew_date" value={formData.hebrew_date} onChange={handleChange} required />
          </label>

          <label>
            שעת האירוע:
            <input type="time" name="time" value={formData.time} onChange={handleChange} required />
          </label>

          <div className="terms">
            <label>
              <input
                type="checkbox"
                name="isSeparatedEvent"
                checked={formData.isSeparatedEvent}
                onChange={handleChange}
              />
              <span>האם האירוע בהפרדה מלאה?</span>
            </label>
            {formData.isSeparatedEvent && <small>נשאל את המוזמנים כמה בנים וכמה בנות מגיעים</small>}
          </div>

          <div className="terms">
            <label>
              <input type="checkbox" name="askKids" checked={formData.askKids} onChange={handleChange} />
              <span>לשאול את המוזמנים האם מגיעים ילדים</span>
            </label>
          </div>

          <div className="terms">
            <label>
              <input type="checkbox" name="askVegetarian" checked={formData.askVegetarian} onChange={handleChange} />
              <span>לשאול את המוזמנים האם הם צריכים מנות צמחוניות</span>
            </label>
          </div>

          <div className="terms">
            <label>
              <input type="checkbox" name="askDrive" checked={formData.askDrive} onChange={handleChange} />
              <span>לשאול את המוזמנים האם הם מגיעים בהסעה</span>
            </label>
          </div>

          {formData.askDrive && (
            <div style={{ marginTop: 10 }}>
              {renderShuttleBox("מאיפה ההסעה? (עד 3 מקומות) — בעברית + אופציונלי באנגלית/צרפתית")}
            </div>
          )}

          <label>
            מספר טלפון:
            <input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
          </label>

          {renderHebrewInvitationPicker()}

          <div style={{ marginTop: 22, paddingTop: 10, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
            <p className="invitation-text" style={{ fontWeight: 800 }}>
              הזמנה + פרטים בשפות נוספות (אופציונלי)
            </p>

            <button
              type="button"
              onClick={() => {
                setLangTab("en");
                setShowLangModal(true);
              }}
            >
              עריכה באנגלית / צרפתית
            </button>

            <p className="invitation-text" style={{ marginTop: 8, opacity: 0.85 }}>
              לא חובה למלא — אם לא תעלו/תמלאו, המערכת תשתמש בעברית כברירת מחדל.
            </p>
          </div>

          {renderLangModal()}

          <label>
            קוד קופון:
            <input
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder="הכנס קוד קופון"
            />
          </label>

          <label>
            רשומות נוספות (שקל לרשומה):
            <input type="number" name="extraRecords" value={formData.extraRecords} onChange={handleChange} min="0" />
          </label>

          <div className="terms">
            <label>
              <input type="checkbox" name="willMariageCame" checked={formData.willMariageCame} onChange={handleChange} />
              <span>צוות מריאז מגיעים לאולם (תוספת 1,200₪)</span>
            </label>
          </div>

          <label>
            אימייל:
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </label>

          <label>
            יצירת סיסמא:
            <input type="password" name="password" value={formData.password} onChange={handleChange} required />
          </label>

          <div className="terms">
            <label>
              <input type="checkbox" checked={termsAccepted} onChange={() => setTermsAccepted(!termsAccepted)} />
              <span>
                אני מאשר את <Link to="/useterms">תנאי השימוש</Link> ואת <Link to="/privacy">מדיניות הפרטיות</Link>
              </span>
            </label>
          </div>

          <button type="submit">המשך לתשלום</button>

          {loading && (
            <div className="loading-overlay" role="dialog" aria-modal="true">
              <div className="loading-popup">⏳ מעבד נתונים... ההרשמה שלך בעיבוד, נא להמתין</div>
            </div>
          )}
        </form>

        {showPopup && (
          <div className="popup-overlay" role="dialog" aria-modal="true">
            <div className="popup-box">
              <h2>ראינו שלא סימנת שצוות מריאז יגיע לאולם</h2>
              <p>
                במחיר של 1,200 שח בלבד אתה מקבל שני אנשי צוות מקצועיים
                <br />
                שיגיעו לפני האירוע ויישארו איתך עד שאחרון האורחים ידע איפה הוא יושב
              </p>
              <div className="popup-buttons">
                <button className="decline-btn" onClick={() => handlePopupChoice("no")}>
                  אני לא מעוניין
                </button>
                <button className="confirm-btn" onClick={() => handlePopupChoice("yes")}>
                  אני אשמח שצוות מריאז יגיעו לאירוע
                </button>
              </div>
            </div>
          </div>
        )}

        {showTranzila && (
          <div className="paypal-modal" role="dialog" aria-modal="true">
            <div className="paypal-container">
              <button className="close-modal" aria-label="סגירת חלון" onClick={() => setShowTranzila(false)}>
                ×
              </button>
              <h2>תשלום מאובטח - טרנזילה</h2>
              <iframe
                src={tranzilaUrl}
                title="Tranzila payment"
                style={{ width: "100%", height: "500px", border: "none" }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Buy;